/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Choose_FolderInputs */

const en_audio_choose_folder = /** @type {(inputs: Audio_Choose_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose folder`)
};

const es_audio_choose_folder = /** @type {(inputs: Audio_Choose_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegir carpeta`)
};

/**
* | output |
* | --- |
* | "Choose folder" |
*
* @param {Audio_Choose_FolderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audio_choose_folder = /** @type {((inputs?: Audio_Choose_FolderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Choose_FolderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_audio_choose_folder(inputs)
	return en_audio_choose_folder(inputs)
});